import { ShoppingCart } from 'lucide-react';
import { RetailerLinks, AffiliateDisclosure } from '@/components/AffiliateLinks';

// "Where to buy" block shown on calculator pages. `keywords` is [{label, q}].
export default function BuyMaterials({ keywords }) {
  if (!keywords || keywords.length === 0) return null;
  return (
    <section className="mt-10 tm-card p-5 border border-slate-200" data-testid="buy-materials">
      <div className="flex items-center gap-2 mb-1">
        <ShoppingCart size={20} className="text-brand" />
        <h2 className="font-display font-bold text-lg uppercase tracking-tight">Where to buy</h2>
      </div>
      <p className="text-slate-600 text-sm mb-4">
        Got your quantities? Compare prices and order the materials from the UK's biggest merchants.
      </p>
      <div className="space-y-4">
        {keywords.map((k) => (
          <div key={k.q} data-testid={`buy-group-${k.q.replace(/\s+/g, '-')}`}>
            <p className="text-[11px] uppercase tracking-widest text-slate-500 mb-2 font-semibold">{k.label}</p>
            <RetailerLinks q={k.q} />
          </div>
        ))}
      </div>
      <div className="mt-4 flex items-center flex-wrap gap-3">
        <AffiliateDisclosure />
      </div>
    </section>
  );
}
